import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';
import { collapsedLinkClass } from './constants';

export const trackDimensionExpansion = (showMoreColorsLink: HTMLElement) => {
    const isCollapsed = showMoreColorsLink.classList.contains(collapsedLinkClass);
    trackEvent({ product_DimensionFold: [isCollapsed ? 'more' : 'less'] });
};
